<template>
  <v-switch
    v-if="push !== undefined"
    class="push"
    v-model="push"
    hide-details
  ></v-switch>
</template>
<script>
export default {
  name: "Push",
  data() {
    return {
      // push: undefined,
      push: true,
    };
  },
  computed: {
    token() {
      return window.localStorage.getItem("pushToken");
    },
  },
  watch: {
    push() {
      // this.toggleToken();
    },
  },
  methods: {
    getToken() {
      this.$axios.get("/users/tokens?token=" + this.token).then((response) => {
        this.push = response.data;
      });
    },
    toggleToken() {
      this.$axios
        .put("/users/tokens", { token: this.token, is_on: this.push })
        .then((response) => {
          this.push = response.data;
        });
    },
  },
  mounted() {
    // this.getToken();
  },
};
</script>
<style lang="scss">
.push{
  .v-input--switch__track{
    height: 20px;
    border-radius: 20px;
    opacity: 1;
  }
  .v-input--switch__thumb{
    width: 14px;
    height: 14px;
    top: 8px;
    left: 4px;
    background-color: #fff;
  }
  .v-input--selection-controls__ripple{
    display: none;
  }
  .v-input--selection-controls__ripple:before{
    left: 12px;
  }
  &.v-application--is-ltr .v-input--switch .v-input--selection-controls__ripple{
    left: -8px;
  }
  &.v-input--selection-controls{
    margin-top: 0;
    padding-top: 0;
  }
  &.v-application--is-ltr .v-input--selection-controls__input{
    margin-right: 0;
  }
  .v-input--switch .v-input--selection-controls__ripple{
    top: calc(50% - 12px);
  }
  &.v-input--switch:not(.v-input--switch--flat):not(.v-input--switch--inset) .v-input--switch__thumb{
    box-shadow: none;
  }
  &.v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple, 
  &.v-input--switch.v-input--is-dirty .v-input--switch__thumb{
    transform: translate(18px, 0) !important;
  }
  .v-input--selection-controls__input{
    margin-right: 0 !important;
  }
}
</style>